<template>
  <div class="position-relative archive bg-color-light text-color-dark">
    <vue-headful :title="doctitle" />
    <b-container class="pb-5 pt-4" style="height: 499px">
      <b-row>
        <b-col xl="2"></b-col>
        <b-col>
          <h1 class="mt-5 big-headline">Archive</h1>
          <p class="text-color-dark">
            You can have a look at Øredev’s Conference previous years; from the
            fifth Øredev in 2009 up to the one last year. You can watch our
            videos from previous years at our Øredev
            <a
              href="https://www.youtube.com/@OredevConference"
              target="_blank"
              rel="noopener noreferrer"
              class=""
              >channel</a
            >.
          </p>

          <div class="d-flex flex-wrap">
            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2023/index.html#/"
            >
              2023
            </a>
            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2022/index.html#/"
            >
              2022
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2019/home.html"
            >
              2019
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2018/2018.html"
            >
              2018
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2017/2017/start.html"
            >
              2017
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2016/2016.html"
            >
              2016
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/2015/2015.html"
            >
              2015
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/oredev2014/index.html"
            >
              2014
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/oredev2013/2013.html"
            >
              2013
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/oredev2012/2012/start.html"
            >
              2012
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/oredev2011/2011/start.html"
            >
              2011
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/oredev2010/2010.html"
            >
              2010
            </a>

            <a
              class="archive-link"
              target="_blank"
              href="https://archive.oredev.org/oredev2009/2009/start.html"
            >
              2009
            </a>
          </div>

          <div class="text-center mt-5 mb-5">
            <b-img
              id="red-dots"
              class="text-center dots"
              fluid
              src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712254780/2024/blue_dots.png"
            ></b-img>
          </div>
        </b-col>
        <b-col xl="2"></b-col>
      </b-row>
    </b-container>

    <b-container fluid class="px-0 mt-4">
      <b-row no-gutters class="pb-1">
        <b-col cols="12" md="4">
          <b-img
            class="info-img pr-0 pr-md-1 pb-1 pb-md-0"
            src="https://res.cloudinary.com/oredev/image/upload/v1713356087/2024/e63a00cb2c904d7a78d46971971ab04f.jpg"
          ></b-img>
        </b-col>
        <b-col cols="12" md="4">
          <b-img
            class="info-img pr-0 pr-md-1 pb-1 pb-md-0"
            src="https://res.cloudinary.com/oredev/image/upload/v1713356086/2024/36a9f727cb779c2fe454347b34828808.jpg"
          ></b-img>
        </b-col>
        <b-col cols="12" md="4">
          <b-img
            class="info-img"
            src="https://res.cloudinary.com/oredev/image/upload/v1713356086/2024/04f46b9f2fb226018d7d5f37e7f602a8.jpg"
          ></b-img>
        </b-col>
      </b-row>
    </b-container>

    <b-img
      class="position-absolute d-none d-md-block"
      style="top: 7%; right: 2%; width: 10%"
      src="https://res.cloudinary.com/oredev/image/upload/v1712254780/2024/Blue_x.png"
    >
    </b-img>
    <b-img
      class="position-absolute d-none d-md-block"
      style="top: 27%; left: 2%; width: 10%"
      src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712152462/2024/Asset_38_3x.png"
    >
    </b-img>
    <b-img
      class="position-absolute d-block d-md-none"
      style="top: 30%; right: 4%; width: 20%"
      src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1712152462/2024/Asset_38_3x.png"
    >
    </b-img>
  </div>
</template>

<script>
export default {
  name: "archive",
  data() {
    return {
      doctitle: "Archive - " + this.$store.state.conferencename,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
ul {
  list-style: none;
  padding-left: 0;
}

.btn-1 {
  background: #292929 !important;
}

.btn-1:hover {
  background: $orange !important;
  color: white !important;
}

.archive-link {
  text-decoration: none !important;
}
button {
  margin-bottom: 5px;
}

.archive-link {
  padding: 1rem;
  font-family: Outfit;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 29px;
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Archive.vue